import { ArrowUp } from "lucide-react";
import { useLang, scrollToId } from "./ctx";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#FBFAF7]" data-testid="footer">
      <div className="mx-auto max-w-[1440px] px-6 py-16 lg:px-12">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-end">
          <img src="/assets/logo-dark.png" alt="Balgat Mining" className="h-20 w-auto self-start" />
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {["about", "kaolin", "process", "contact"].map((id) => (
              <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="text-sm text-stone-600 transition-colors duration-300 hover:text-stone-950">{t.nav[id]}</button>
            ))}
          </div>
        </div>
        <div className="mt-14 flex flex-col justify-between gap-4 border-t border-stone-200 pt-8 text-xs text-stone-500 sm:flex-row sm:items-center">
          <span>© {new Date().getFullYear()} Balgat Mining. {t.footer.rights}</span>
          <button data-testid="footer-back-to-top" onClick={() => scrollToId("top")} className="flex items-center gap-2 font-mono uppercase tracking-[0.25em] hover:text-stone-950">
            {t.footer.top} <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
};
